<!--
  - Copyright (c) 2019 LNBIG.com
  - All rights reserved.
  -->

<template>
  <v-snackbar
    v-model="show"
    :color="color"
    multi-line="multi-line"
    :timeout="timeout"
  >
    {{ text }}
    <v-btn
      dark
      text
      @click="show = false"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
                color: 'success',
                timeout: 1700,
                text: ''
            }
        },
        mounted: function () {
            console.log('snackBar mounted')
        }
    }
</script>
